import { type PropsWithChildren } from 'react'

import styles from './LinkifiedText.module.css'

/**
 * The anchor `LinkifiedText` renders, on its own so a server template can emit the same markup: the
 * class is hashed per build, and only a component can carry it into the generated PHP.
 */
export const LinkifiedLink = ({ href, children }: PropsWithChildren<{ href: string }>) => (
    <a
        href={href}
        target="_blank"
        // `ugc` marks it as user-generated, which is the whole point here; the lint rule predates it
        // being a standard rel value.
        // eslint-disable-next-line react/no-invalid-html-attribute
        rel="nofollow ugc noopener noreferrer"
        className={styles.link}
    >
        {children}
    </a>
)
